/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsUpdateReportDefinitionMutationRequest, AuditReportsUpdateReportDefinitionMutationResponse, AuditReportsUpdateReportDefinitionPathParams, AuditReportsUpdateReportDefinition400, AuditReportsUpdateReportDefinition401, AuditReportsUpdateReportDefinition403, AuditReportsUpdateReportDefinition404 } from "../models/AuditReportsUpdateReportDefinition";

export function getAuditReportsUpdateReportDefinitionUrl(id: AuditReportsUpdateReportDefinitionPathParams["id"]) {
  const res = { method: 'PUT', url: `/audit-reports/v1/report-definitions/${id}` as const }
  return res
}

/**
 * @description Updates the report definition by its unique identifier. The definition must match the blueprint version of the existing entity. If isDefault is set to true, this definition will be set as the default for its report type and other defaults will be unset.
 * @summary Update report definition
 * {@link /audit-reports/v1/report-definitions/:id}
 */
export async function auditReportsUpdateReportDefinition(id: AuditReportsUpdateReportDefinitionPathParams["id"], data: AuditReportsUpdateReportDefinitionMutationRequest, config: Partial<RequestConfig<AuditReportsUpdateReportDefinitionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsUpdateReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsUpdateReportDefinition400 | AuditReportsUpdateReportDefinition401 | AuditReportsUpdateReportDefinition403 | AuditReportsUpdateReportDefinition404>, AuditReportsUpdateReportDefinitionMutationRequest>({ method : "PUT", url : getAuditReportsUpdateReportDefinitionUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}